import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default class FoodItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  foodItemStyle = (item, filter) => {
    var display = item.category === filter ? 'block' : 'none';
    display = filter === 'Alle' ? 'block' : display;

    let search = this.props.search.toLowerCase();

    if ((display === 'block') & (search !== '')) {
      let inName = item.name.toLowerCase().includes(search);
      let inIngr = item.ingredients ? item.ingredients : [];

      inIngr = inIngr
        .map(ingr => (ingr.ingredient.toLowerCase().includes(search) ? 1 : 0))
        .reduce((a, b) => a + b, 0);
      inIngr = inIngr > 0 ? true : false;
      if (!inIngr & !inName) {
        display = 'none';
      }
    }

    return {
      background: 'url(' + item.src + ')',
      transition: '0.5s ease',
      display: display
    };
  };

  handleClick() {
    this.props.onClick(this.props.index);
  }

  render() {
    return (
      <div
        onClick={this.handleClick}
        className="food-item"
        style={this.foodItemStyle(this.props.foodItem, this.props.filter)}
      >
        <div className="text">{this.props.foodItem.name}</div>

        <div className="btn-area">
          <div className="btn-gray done" onClick={this.handleCountClick}>
            {this.props.foodItem.count} <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="btn-gray like" onClick={this.handleRatingClick}>
            {this.props.foodItem.rating} <FontAwesomeIcon icon={faThumbsUp} />
          </div>
        </div>
      </div>
    );
  }
}
